import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../src/config";
import { Container, Row, Col, Card, Badge, Button, Alert, Form, Modal } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import 'bootstrap/dist/css/bootstrap.min.css';
import AdminGeralLayout from "../../components/AdminGeralLayout/AdminGeralLayout";
import CardViewTable from "../../components/CardViewTable/CardViewTable";

function ClientesMaster() {
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");
  const [filtroAtivo, setFiltroAtivo] = useState("todos");
  const navigate = useNavigate();

  useEffect(() => {
    carregarClientes();
  }, [filtroAtivo]);

  const carregarClientes = async () => {
    try {
      const token = Cookies.get("authToken");
      let url = `${API_BASE_URL}/admin-geral/clientes-master`;
      
      if (filtroAtivo === "ativos") {
        url += "?ativo=true";
      } else if (filtroAtivo === "inativos") {
        url += "?ativo=false";
      }

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setClientes(response.data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setErro("Erro ao carregar clientes.");
      setLoading(false);
    }
  };

  const handleAtivar = async (id) => {
    try {
      const token = Cookies.get("authToken");
      await axios.patch(`${API_BASE_URL}/admin-geral/clientes-master/${id}/ativar`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSucesso("Cliente ativado com sucesso!");
      carregarClientes();
      setTimeout(() => setSucesso(""), 3000);
    } catch (err) {
      console.error(err);
      setErro("Erro ao ativar cliente.");
    }
  };

  const handleDesativar = async (id) => {
    if (!(await window.globalConfirm("Tem certeza que deseja desativar este cliente?"))) {
      return;
    }

    try {
      const token = Cookies.get("authToken");
      await axios.patch(`${API_BASE_URL}/admin-geral/clientes-master/${id}/desativar`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSucesso("Cliente desativado com sucesso!");
      carregarClientes();
      setTimeout(() => setSucesso(""), 3000);
    } catch (err) {
      console.error(err);
      setErro("Erro ao desativar cliente.");
    }
  };

  const formatarData = (data) => {
    if (!data) return "-";
    return new Date(data).toLocaleDateString('pt-BR');
  };

  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
  };

  const calcularDiasRestantes = (dataVencimento) => {
    if (!dataVencimento) return null;
    const hoje = new Date();
    const vencimento = new Date(dataVencimento);
    const diff = Math.ceil((vencimento - hoje) / (1000 * 60 * 60 * 24));
    return diff;
  };

  return (
    <AdminGeralLayout activeKeyProp="clientes-master">
      <div className="mb-4">
        <h1>Gerenciar Clientes Master</h1>
        <p className="text-muted">Lista completa de todos os clientes master cadastrados.</p>
      </div>

      {loading ? (
        <p>Carregando...</p>
      ) : (
        <Container fluid className="p-0">
          <Row className="mb-3">
            <Col>
              <Button 
                variant="success" 
                onClick={() => navigate("/admin-geral/clientes-master/novo")}
              >
                + Novo Cliente
              </Button>
            </Col>
          </Row>

          {erro && <Alert variant="danger" onClose={() => setErro("")} dismissible>{erro}</Alert>}
          {sucesso && <Alert variant="success" onClose={() => setSucesso("")} dismissible>{sucesso}</Alert>}

          {/* Filtros */}
          <Card className="shadow-sm mb-3" style={{width: "100%"}}>
            <Card.Body>
              <Form.Group>
                <Form.Label>Filtrar por status:</Form.Label>
                <div>
                  <Form.Check
                    inline
                    type="radio"
                    label="Todos"
                    name="filtroAtivo"
                    checked={filtroAtivo === "todos"}
                    onChange={() => setFiltroAtivo("todos")}
                  />
                  <Form.Check
                    inline
                    type="radio"
                    label="Ativos"
                    name="filtroAtivo"
                    checked={filtroAtivo === "ativos"}
                    onChange={() => setFiltroAtivo("ativos")}
                  />
                  <Form.Check
                    inline
                    type="radio"
                    label="Inativos"
                    name="filtroAtivo"
                    checked={filtroAtivo === "inativos"}
                    onChange={() => setFiltroAtivo("inativos")}
                  />
                </div>
              </Form.Group>
            </Card.Body>
          </Card>

          {/* Tabela de Clientes */}
          <Card className="shadow-sm" style={{width: "100%"}}>
            <Card.Body>
              {clientes.length > 0 ? (
                <CardViewTable
                  data={clientes}
                  keyField="id"
                  cardTitleKey="nome"
                  columns={[
                    { key: 'id', header: 'ID' },
                    { key: 'nome', header: 'Nome' },
                    { key: 'celular', header: 'Celular' },
                    {
                      key: 'status',
                      header: 'Status',
                      render: (cliente) => (
                        <Badge bg={cliente.ativo ? "success" : "danger"}>
                          {cliente.ativo ? "Ativo" : "Inativo"}
                        </Badge>
                      ),
                    },
                    {
                      key: 'valorMensalidade',
                      header: 'Mensalidade',
                      render: (cliente) => formatarMoeda(cliente.valorMensalidade),
                    },
                    {
                      key: 'dataVencimento',
                      header: 'Vencimento',
                      render: (cliente) => formatarData(cliente.dataVencimento),
                    },
                    {
                      key: 'diasRestantes',
                      header: 'Dias Restantes',
                      render: (cliente) => {
                        const diasRestantes = calcularDiasRestantes(cliente.dataVencimento);
                        return diasRestantes !== null ? (
                          <Badge bg={diasRestantes <= 3 ? "danger" : diasRestantes <= 7 ? "warning" : "secondary"}>
                            {diasRestantes > 0 ? `${diasRestantes} dias` : "Vencido"}
                          </Badge>
                        ) : (
                          "-"
                        );
                      },
                    },
                    {
                      key: 'actions',
                      header: 'Ações',
                    },
                  ]}
                  actions={(cliente) => (
                    <div className="d-flex flex-wrap gap-2">
                      <Button 
                        size="sm" 
                        variant="info"
                        onClick={() => navigate(`/admin-geral/clientes-master/${cliente.id}/editar`)}
                        className="flex-grow-1"
                      >
                        Editar
                      </Button>
                      <Button 
                        size="sm" 
                        variant="primary"
                        onClick={() => navigate(`/admin-geral/clientes-master/${cliente.id}/renovar`)}
                        className="flex-grow-1"
                      >
                        Renovar
                      </Button>
                      {cliente.ativo ? (
                        <Button 
                          size="sm" 
                          variant="danger"
                          onClick={() => handleDesativar(cliente.id)}
                          className="flex-grow-1"
                        >
                          Desativar
                        </Button>
                      ) : (
                        <Button 
                          size="sm" 
                          variant="success"
                          onClick={() => handleAtivar(cliente.id)}
                          className="flex-grow-1"
                        >
                          Ativar
                        </Button>
                      )}
                    </div>
                  )}
                />
              ) : (
                <Alert variant="info" className="text-center mb-0">
                  Nenhum cliente encontrado.
                </Alert>
              )}
            </Card.Body>
          </Card>
        </Container>
      )}
    </AdminGeralLayout>
  );
}

export default ClientesMaster;
